/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import PersonMatches from 'DesignSystem/PersonMatches/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/SimilarPatients/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let appointmentOverlayPatientNewPersonFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.person.first_name',
})
let appointmentOverlayPatientNewPersonLastNameValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.person.last_name',
})
let appointmentOverlayPatientNewPersonBirthDateValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.person.birth_date',
})
let onIgnoreMatches = fromHelpers.useOnIgnoreMatches({
  children,
  viewPath
  
})
let onUseSelectedLead = fromHelpers.useOnUseSelectedLead({
  children,
  viewPath
  
})
let onUseSelectedPatient = fromHelpers.useOnUseSelectedPatient({
  children,
  viewPath
  
})
let onUseSelectedPerson = fromHelpers.useOnUseSelectedPerson({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<PersonMatches
  viewPath={`${viewPath}/PersonMatches`}
 data="appointment_overlay.patient_new.person.first_name"
 firstName={appointmentOverlayPatientNewPersonFirstNameValueData}
 data="appointment_overlay.patient_new.person.last_name"
 lastName={appointmentOverlayPatientNewPersonLastNameValueData}
 data="appointment_overlay.patient_new.person.birth_date"
 birthDate={appointmentOverlayPatientNewPersonBirthDateValueData}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 onCancel={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 onIgnoreMatches={onIgnoreMatches}
 onUseSelectedLead={onUseSelectedLead}
 onUseSelectedPatient={onUseSelectedPatient}
 onUseSelectedPerson={onUseSelectedPerson}
/>
{children}
</React.Fragment>)
}